import Module from '../utils/Module';
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ArticlesHubModule extends Module {
  constructor (options) {
    super(options);

    this.DOMEl = this.options.element;

    this.categoryFilter = this.DOMEl.querySelectorAll(".filters .filter-category");
    this.selects = this.DOMEl.querySelectorAll('select:not(.js-webform-select2)');
    this.articlesCards = this.DOMEl.querySelectorAll(".article-card");

    this.ArticleGrid = this.DOMEl.querySelector(".articles-hub__cards");

    this.init();
  }

  init () {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var category = url.searchParams.get("category");


    this.categoryFilter.forEach(select => {
      select.addEventListener('change', () => {
        this.onFilterChange(select);
      });
    });

    this.articlesCards.forEach(card => {
      card.addEventListener('click', () => {
        this.trackArticleClick(card);
      });
    });

    this.selects.forEach(select => {
      var numberOfOptions = select.childElementCount;

      select.classList.add('select-hidden');
      var divSelect = document.createElement('div');
      divSelect.classList.add('select');
      this.wrap(select, divSelect);

      var divSelectStyled = document.createElement('div');
      divSelectStyled.classList.add('select-styled');
      divSelect.appendChild(divSelectStyled);

      var styledSelect = select.parentNode.querySelector('div.select-styled');
      styledSelect.innerText = select[0].innerText;

      var list = document.createElement('ul');
      list.classList.add('select-options');
      styledSelect.parentNode.insertBefore(list, styledSelect.nextSibling);
      //styledSelect.appendChild(list);

      for (var i = 0; i < numberOfOptions; i++) {
        var li = document.createElement('li');
        li.innerText = select[i].innerText;
        li.setAttribute("rel", select[i].value);
        list.appendChild(li);
      }

      var listItems = list.querySelectorAll('li');

      listItems.forEach(item => {

        if(item.getAttribute("rel") == category)
        {
          styledSelect.innerText = item.innerText;
          for (var opt, j = 0; opt = select[j]; j++) {
            if (opt.value == item.getAttribute("rel")) {
              select[j].selected = true;
              select.selectedIndex = j;
              break;
            }
          }
        }
        item.addEventListener('click', () => {
          styledSelect.innerText = item.innerText;
          styledSelect.classList.remove('active');
          for (var opt, j = 0; opt = select[j]; j++) {
            if (opt.value == item.getAttribute("rel")) {
              select[j].selected = true;
              select.selectedIndex = j;
              this.onFilterChange(select);
              break;
            }
          }
          list.classList.remove('active');

        })
      });

      styledSelect.addEventListener('click', () => {


        if (styledSelect.classList.contains('active')) {
          styledSelect.classList.remove('active');
          list.classList.remove('active');
        } else {
          styledSelect.classList.add('active');
          list.classList.add('active');
        }
      });

      this.DOMEl.addEventListener('click', (e) => {
        if (e.target != styledSelect) {
          styledSelect.classList.remove('active');
          list.classList.remove('active');
          gsap.delayedCall(0.3, () => {
            //styledSelect.nextElementSibling.style.display = 'none'
          });

        }
      });
    });

    ScrollTrigger.create({
      trigger: this.ArticleGrid,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.articlesCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      },
      onEnterBack: ()=>{
        gsap.to(this.articlesCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      }
    });
  }

  onFilterChange(select) {
    let category = select.options[select.selectedIndex].value;
    let categoryText = select.options[select.selectedIndex].innerText;
    this.trackCategoryChange(categoryText);

    if (category !== '') {
      window.location = '?category=' + category;
    } else {
      window.location = window.location.href.split('?')[0];
    }
  }

  wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }

  trackArticleClick(articleCard) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "news interaction",
        "action": articleCard.querySelector('.article-title').innerHTML.trim(),
        "label": window.location.href
      }
    });
  }

  trackCategoryChange(category) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "news interaction",
        "action": 'filter',
        "label": category
      }
    });
  }
}
